<span class="badge-cell {{ badge.class }}" [matTooltip]="tooltipLabel | translate" [matTooltipDisabled]="!tooltipLabel">
  {{ badge.label | uppercase | translate }}
</span>
